import { render, staticRenderFns } from "./Speech.vue?vue&type=template&id=2540044b&scoped=true&"
import script from "./Speech.vue?vue&type=script&lang=ts&"
export * from "./Speech.vue?vue&type=script&lang=ts&"
import style0 from "./Speech.vue?vue&type=style&index=0&id=2540044b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2540044b",
  null
  
)

component.options.__file = "Speech.vue"
export default component.exports